import { get } from "lodash";
import RichTextInput from "ra-input-rich-text";
import React from "react";
import {
	BooleanInput,
	CheckboxGroupInput,
	maxLength,
	required,
	TextInput,
} from "react-admin";
import { useFormState } from "react-final-form";
import RaInput from "../../components/inputs/RaInput";
import * as Validation from "../../utils/validation";
import paymentMethods from "../paymentMethods";
import ImageInput from "./ImageInput";

const optionalUrl = () => (value) => {
	if (!value || value.length === 0) return undefined;
	let valid = Validation.url(value);
	return valid === true ? undefined : valid;
};

const BcInput = ({ ...props }) => {
	const formState = useFormState();
	const bcEnabled = get(formState.values, "bc_enabled", false);
	return (
		<React.Fragment>
			<RaInput>
				<BooleanInput {...props} source="bc_enabled" />
			</RaInput>
			{bcEnabled && (
				<React.Fragment>
					<RaInput>
						<TextInput {...props} source="bc_name" fullWidth className="" />
					</RaInput>
					<RaInput>
						<ImageInput {...props} source="bc_logo" />
					</RaInput>
					<RaInput>
						<CheckboxGroupInput
							{...props}
							source="bc_accepted_payment_methods"
							choices={paymentMethods}
							validate={[maxLength(255), required()]}
							parse={(pm) => (pm ? pm.join(",") : "")}
							format={(pm) => (pm ? pm.split(",") : [])}
						/>
					</RaInput>
					<RaInput>
						<RichTextInput
							{...props}
							source="bc_description"
							multline
							fullWidth
							className=""
						/>
					</RaInput>
					<RaInput>
						<RichTextInput
							{...props}
							source="bc_description_banner"
							multline
							fullWidth
							className=""
							validate={maxLength(50)}
						/>
					</RaInput>
					<RaInput>
						<RichTextInput
							{...props}
							source="bc_terms_and_conditions_text"
							multline
							fullWidth
							className=""
						/>
					</RaInput>
					<RaInput>
						<TextInput
							{...props}
							source="bc_terms_and_conditions_url"
							validate={[optionalUrl(), maxLength(1024)]}
							fullWidth
							className=""
						/>
					</RaInput>
				</React.Fragment>
			)}
		</React.Fragment>
	);
};

export default BcInput;
